var arrayMap=require("./_arrayMap");function baseValues(r,a){return arrayMap(a,function(a){return r[a]})}module.exports=baseValues;